import { HeadCell } from 'models';
import { PURCHASE_HISTORY_ITEM_RESPONSE } from 'models/subscription';

export const purchaseHeadCells: readonly HeadCell<PURCHASE_HISTORY_ITEM_RESPONSE>[] =
  [
    {
      id: 'id',
      numeric: false,
      disablePadding: true,
      isSort: false,
      label: 'Package',
    },
    {
      id: 'parent_rate',
      numeric: false,
      disablePadding: false,
      isSort: false,
      label: 'Package Rate',
    },
    {
      id: 'package',
      numeric: false,
      disablePadding: false,
      isSort: false,
      label: 'Package Amount',
    },
    {
      id: 'balance',
      numeric: false,
      disablePadding: false,
      isSort: false,
      label: 'Package Balance',
    },
    {
      id: 'createdAt',
      numeric: false,
      disablePadding: false,
      isSort: true,
      label: 'Purchased Date',
    },
    {
      id: 'expiredAt',
      numeric: false,
      disablePadding: false,
      isSort: true,
      label: 'Expired Date',
    },
  ];
